<div>
  <div class="mb-3">
    <label for="name" class="form-label">Scenario name</label>
    <input [(ngModel)]="name" type="text" class="form-control" name="name" [ngClass]=" {'validated': name, 'not-validated' :!name }">
  </div>
  <div class="mb-3">
    <label for="department" class="form-label">Department</label>
    <select class="form-select" [(ngModel)]="department_id" [ngClass]=" {'validated': department_id !=0, 'not-validated' : department_id==0 }">
      <option value="0" selected>Please select an department</option>
      <option *ngFor="let item of departments[0]" value="{{item.id}}">{{item.name}}</option>
    </select>
  </div>
  <div class="mb-3">
    <label for="scenario" class="form-label">Scenario</label>
    <textarea [(ngModel)]="scenario" type="text" class="form-control" name="scenario" rows="3" disabled></textarea>
  </div>

  <div class="mb-3 input-group">
    <button class="btn btn-outline-primary" type="button" (click)="addUrl()">Add url</button>
    <input [(ngModel)]="addurl" type="text" class="form-control" name="url" placeholder="url">
  </div>
  <div class="mb-3 input-group">
    <button class="btn btn-outline-primary" type="button" (click)="addPause()">Add pause</button>
    <input [(ngModel)]="addpause" type="text" class="form-control" name="pause" placeholder="Pause value in ms">
  </div>

  <div class="mb-3 input-group">
    <button class="btn btn-outline-primary" type="button" (click)="addFormItem()">Add form item</button>
    <input [(ngModel)]="addformid" type="text" class="form-control" name="formid"
      placeholder="Form identifier id or class name">
    <input [(ngModel)]="addformvalue" type="text" class="form-control" name="formvalue" placeholder="Value to use">
  </div>

  <div class="mb-3 input-group">
    <button class="btn btn-outline-primary" type="button" (click)="addFormclick()">Add form click</button>
    <input [(ngModel)]="addformclick" type="text" class="form-control" name="formclick"
      placeholder="Form identifier id or class name">
  </div>

  <div class="mb-3 input-group">
    <button class="btn btn-outline-primary" type="button" (click)="addFormSubmit()">Add form submit</button>
    <input [(ngModel)]="addformsubmit" type="text" class="form-control" name="formsubmit"
      placeholder="Form identifier id or class name">
  </div>

  <div class="mb-3">

    <div class="card">
      <div class="card-header">
        Scenario
      </div>
      <div class="card-body">
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let item of scenarioItems; ; let i = index" [attr.data-index]="i">
            <div class="input-group mb-3">
              <span class="input-group-text">{{item.type}}</span>
              <input type="text" class="form-control" value="{{item.description}}" disabled>
              <button class="btn btn-outline-danger" type="button" id="button-addon2" 
                (click)="remove(i)">Remove</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <button (click)="save()" class="btn btn-primary">Save</button>
</div>
